import type { IconData } from '@stacksjs/iconify-core'

export const warning: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M240 176h32v176h-32zm0 208h32v32h-32z\"/><path fill=\"currentColor\" d=\"M274.014 16h-36.028L16 445.174V496h480v-50.826ZM464 464H48v-11.041L256 50.826l208 402.133Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default warning
